/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useCallback, useEffect, useState } from 'react'
import { DashboardHeader } from '../../components/dashboard/DashboardHeader'
import { ActionCentre } from '../../components/dashboard/action-centre/ActionCentre'

const DashboardWrapper: FC = () => {
    useEffect(() => {
      document.title = `ADI Network App | Dashboard | ADI Network`;
    }, []);

    const total = 5;

    const [loadedCount, setLoadedCount] = useState(0);
    const [allDone, setAllDone] = useState(false);

    const onChildLoaded = useCallback(() => {
      setLoadedCount(c => c + 1)
    }, [])

    useEffect(() => {
      if (loadedCount === total) {
        setAllDone(true)
      }
    }, [loadedCount, total])
  
  return (
    <>
      <DashboardHeader onLoaded={onChildLoaded} allDone={allDone} />
      <div className='px-5 py-6'>
        <ActionCentre onLoaded={onChildLoaded} allDone={allDone} />
      </div>
    </>
  )
}

export { DashboardWrapper }
